import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { CREATE_FEE, CREATING_FEE, FEES_ERROR, GETTING_FEES, GET_FEES, UPDATE_FEE, UPDATING_FEE } from "../types"

export const createFee = (documentRequestPayload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_FEE,
            payload: true
        })

        const response = await axios.post(`${baseUrl}/fees`, documentRequestPayload, { headers })
        
        dispatch({
            type: CREATE_FEE,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: FEES_ERROR,
            error
        })
    }
}

export const updateFee = (feeId, documentRequestPayload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: UPDATING_FEE,
            payload: true
        })

        const response = await axios.patch(`${baseUrl}/fees/${feeId}`, documentRequestPayload, { headers })
        
        dispatch({
            type: UPDATE_FEE,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: FEES_ERROR,
            error
        })
    }
}

export const fetchFees = (filterString, page, perPage) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `${baseUrl}/fees?expand=feeAccount`
        if(filterString && filterString !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filterString}`
        }

        if(page && page!=='') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage && perPage!=='') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_FEES,
            payload: true
        })

        const response = await axios.get(url, { headers })
        // console.log(response.data.data)
        dispatch({
            type: GET_FEES,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: FEES_ERROR,
            error
        })
    }
}

export const clearCreatedFee = () => async (dispatch) => {    
    dispatch({
        type: CREATE_FEE,
        payload: null
    })   
}

export const clearUpdatedFee = () => async (dispatch) => {    
    dispatch({
        type: UPDATE_FEE,
        payload: null
    })   
}